<template>
  <v-dialog
    persistent
    v-bind="[$attrs, $props]"
    content-class="base__modal pa-10"
    width="600"
  >
    <div class="d-flex justify-space-between align-baseline mb-8">
      <h3 class="primary--text">
        Adicionar Documentos
      </h3>
      <v-btn text @click="$emit('close')">
        <v-icon class="fa dialog__close-btn">fa-times</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <label class="form__label primary--text">
          Buscar
        </label>
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          text-placeholder="Buscar"
        />
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="headers"
          :items="items"
          :search="search"
          item-key="arquivo.url"
          v-model="selected"
          show-select
        >
        </BaseDataTable>
      </v-col>
      <v-col cols="12" class="d-flex justify-end mt-6">
        <BaseButton
          text
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          @click="submit"
        >
          Adicionar
        </BaseButton>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
  name: "SelectDocumentsModal",
  props: {
    filterProps: Object,
    headers: Array,
    items: Array,
    currentDocuments: Array
  },
  data() {
    return {
      search: null,
      selected: []
    };
  },
  created() {
    this.selected = _.cloneDeep(this.currentDocuments);
  },
  methods: {
    submit() {
      this.$emit("select-items", this.selected);
      this.$emit("complete");
    }
  }
};
</script>
